(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dufins-video-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dufins-video-carousel')) {
  customElements.define(
    'dufins-video-carousel',
    class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();

        const options = {
          signal: this.controller.signal
        };

        this.track = this.querySelector('[data-track]');
        this.dialog = this.querySelector('[data-dialog]');
        this.player = this.querySelector('[data-player]');
        this.cards = [...this.querySelectorAll('[data-open]')];
        this.visible = new Set();
        this.previews = new Map();

        this.motion = matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.paused = this.motion.matches;

        const motionButton = this.querySelector('[data-motion]');

        const syncButton = () => {
          if (!motionButton) return;

          motionButton.textContent = this.paused
            ? 'Play previews'
            : 'Pause previews';

          motionButton.setAttribute(
            'aria-pressed',
            String(this.paused)
          );
        };

        syncButton();

        motionButton?.addEventListener(
          'click',
          () => {
            this.paused = !this.paused;
            syncButton();
            this.syncPreviews();
          },
          options
        );

        this.motion.addEventListener(
          'change',
          () => {
            this.paused = this.motion.matches;
            syncButton();
            this.syncPreviews();
          },
          options
        );

        this.querySelector('[data-prev]').addEventListener(
          'click',
          () => this.move(-1),
          options
        );

        this.querySelector('[data-next]').addEventListener(
          'click',
          () => this.move(1),
          options
        );

        this.track.addEventListener(
          'scroll',
          () => this.syncArrows(),
          {
            ...options,
            passive: true
          }
        );

        this.cards.forEach(card => {
          card.addEventListener(
            'click',
            () => this.openVideo(card),
            options
          );
        });

        this.querySelector('[data-close]').addEventListener(
          'click',
          () => this.dialog.close(),
          options
        );

        this.dialog.addEventListener(
          'click',
          event => {
            if (event.target !== this.dialog) return;

            const rect = this.dialog.getBoundingClientRect();

            if (
              event.clientX < rect.left ||
              event.clientX > rect.right ||
              event.clientY < rect.top ||
              event.clientY > rect.bottom
            ) {
              this.dialog.close();
            }
          },
          options
        );

        this.dialog.addEventListener(
          'close',
          () => {
            this.clearPlayer();
            this.syncPreviews();
            this.opener?.focus({
              preventScroll: true
            });
          },
          options
        );

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) {
              this.player.querySelector('video')?.pause();
            }

            this.syncPreviews();
          },
          options
        );

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (
                  entry.isIntersecting &&
                  entry.intersectionRatio >= 0.25
                ) {
                  this.visible.add(entry.target);
                } else {
                  this.visible.delete(entry.target);
                }
              });

              this.syncPreviews();
            },
            {
              threshold: [0, 0.25]
            }
          );

          this.cards.forEach(card => {
            this.observer.observe(card);
          });
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(
            () => this.syncArrows()
          );

          this.resizeObserver.observe(this.track);
        }

        this.addEventListener(
          'shopify:block:select',
          event => {
            event.target.scrollIntoView({
              behavior: 'auto',
              block: 'nearest',
              inline: 'nearest'
            });
          },
          options
        );

        this.syncArrows();
      }

      move(direction) {
        const card = this.track.querySelector('.dvc__card');

        if (!card) return;

        const gap =
          parseFloat(
            getComputedStyle(this.track).columnGap
          ) || 0;

        this.track.scrollBy({
          left:
            direction *
            (card.getBoundingClientRect().width + gap),
          behavior: this.motion.matches
            ? 'auto'
            : 'smooth'
        });
      }

      syncArrows() {
        const max =
          this.track.scrollWidth -
          this.track.clientWidth;

        this.querySelector('[data-prev]').disabled =
          this.track.scrollLeft <= 2;

        this.querySelector('[data-next]').disabled =
          max <= 2 ||
          this.track.scrollLeft >= max - 2;
      }

      syncPreviews() {
        const enabled =
          this.dataset.autoplay === 'true' &&
          !this.paused &&
          !document.hidden &&
          !this.dialog.open;

        this.cards.forEach(card => {
          let video = this.previews.get(card);

          if (enabled && this.visible.has(card)) {
            if (!video) {
              video = card
                .querySelector('template')
                .content
                .querySelector('video')
                .cloneNode(true);

              video.setAttribute('aria-hidden', 'true');
              video.muted = true;
              video.removeAttribute('id');

              video.addEventListener(
                'loadeddata',
                () => card.classList.add('is-ready'),
                {
                  once: true
                }
              );

              card.append(video);
              this.previews.set(card, video);
            }

            video.play()?.catch(() => {});
          } else {
            video?.pause();
          }
        });
      }

      openVideo(card) {
        if (this.dialog.open) return;

        this.opener = card;
        this.clearPlayer();

        const video = card
          .querySelector('template')
          .content
          .querySelector('video')
          .cloneNode(true);

        video.removeAttribute('id');
        video.removeAttribute('muted');
        video.muted = false;
        video.loop = false;
        video.controls = true;
        video.preload = 'metadata';

        video.setAttribute(
          'aria-label',
          card.getAttribute('aria-label')
        );

        this.player.append(video);
        this.dialog.showModal();
        this.syncPreviews();

        video.play()?.catch(() => {});

        this.querySelector('[data-close]').focus();
      }

      clearPlayer() {
        const video = this.player.querySelector('video');

        if (video) {
          video.pause();
          video.removeAttribute('src');

          video.querySelectorAll('source').forEach(source => {
            source.remove();
          });

          video.load();
        }

        this.player.replaceChildren();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();

        this.previews?.forEach(video => {
          video.pause();
        });

        if (this.player) {
          this.clearPlayer();
        }

        if (this.dialog?.open) {
          this.dialog.close();
        }

        this.querySelectorAll(
          '[data-open] > .dvc__video'
        ).forEach(video => {
          video.remove();
        });

        this.querySelectorAll('.is-ready').forEach(card => {
          card.classList.remove('is-ready');
        });

        this.controller = null;
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
     
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
